<template>
    <div class="dianpu-hot">

        <div class="card-list">
            <component @toggle="toggle" :is="componentIndex" :data="componentNeedData" v-for="({componentIndex,componentNeedData},index) in topCardsComponentList" :key="index"/>
            <component :is="componentIndex" :data="componentNeedData" v-for="({componentIndex,componentNeedData},index) in listCardsComponentList" :key="index"/>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters,mapActions } from 'vuex'
import Api from '@/service/api'
import Cookies from 'js-cookie'

export default {
    name:'cateogory-list',
    data(){
        return {
            topCards:[],
            listCards:[],
            topCardsComponentList:[],
            listCardsComponentList:[],
            currentNavIndex:0,
        }
    },

    computed: {
        ...mapGetters('category', {
            count: 'getCount',
            select: 'getSelect'
        }),
    },

    methods:{
        toggle(index){
            this.currentNavIndex = index
            this.getCategoryCardList()
        },
        goToPage(){
            this.$router.push({name:'list',params:{pageId:'1.html'}})
        },

        getIndexChange(index){
            // 存成map，如果index为key的value，则不获取数据，否则重新请求数据
            this.selectIndex = index
        },

        getPageKey(param){
            let regParam = param.regParams
            let biz_params = regParam.biz_params
            let biz_dynamic_params = biz_params.biz_dynamic_params
            let result = biz_dynamic_params && biz_dynamic_params.split('=') && biz_dynamic_params.split('=')[1]
            return result
        },
        async getCategoryCardList(){
            let firstCategoryAction = this.topCards[1] && this.topCards[1].items && this.topCards[1].items[this.currentNavIndex] && this.topCards[1].items[this.currentNavIndex].actions
            let pageKey = this.getPageKey(firstCategoryAction)
            let categoryListData = await Api.read(pageKey,'category-list')
            let categoryListCards = categoryListData && categoryListData.pages[0] &&  categoryListData.pages[0].cards
            this.listCardsComponentList = []
            this.listCardsComponentList = this.$renderCardComponentList(categoryListCards)

        },
        async getTopData(pageKey){
            let data = await Api.read(pageKey,'category-list',true)
            let topData = data.pages[0]
            this.topCards = topData && topData.cards || []
            this.topCardsComponentList = this.$renderCardComponentList(this.topCards)
            this.getCategoryCardList()
            let docTitle = topData && topData.showData && topData.showData.texts && topData.showData.texts[0].text || '知识店铺';

            let homePageUrl = data && data.extend && data.extend.homePageUrl;
            if (homePageUrl) {
                Cookies.set('homePageUrl', homePageUrl);
            }
            let qiyiId = testJson && testJson.extend && testJson.extend.qiyiId;
            if (qiyiId) {
                Cookies.set('qiyiId',qiyiId)
            }

            window.pageTitle = docTitle
            window.storeInfo = data.storeInfo
        }
    },

    created(){
        let param = this.$route.params.pageId;
        if (param) {
            let arr = param.split('.html');
            this.getTopData(arr[0])
        }
        this.$store.dispatch('category/home', false);


    }
}
</script>

<style lang="less">
    .vux-swiper-item{
        overflow-y:auto;
        text-align:center;
    }
</style>
